module.exports = __webpack_public_path__ + "static/img/jar.cb06c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/jar.png
// module id = 6hhG
// module chunks = 53